import {
    client,
    clientBase,
    clientWithoutCache,
    formClient,
} from "./BackendClient";

type RecordObject = Record<string, unknown>;

const getData = async <T = any>(
    url: string,
    options?: RecordObject,
    intercept = true,
) => {
    return intercept
        ? client.get<T>(url, options)
        : clientBase.get<T>(url, options);
};

const getDataWithoutCache = async <T = any>(
    url: string,
    options?: RecordObject,
) => {
    return clientWithoutCache.get<T>(url, options);
};

async function postData(url: string, data: any, options?: any) {
    return client.post(url, data, options);
}

async function postImageData(url: string, data: any, options?: any) {
    return formClient.post(url, data, options);
}

async function putData(url: string, options?: RecordObject) {
    return clientWithoutCache.put(url, options);
}

async function deleteData(url: string, options?: RecordObject) {
    return client.delete(url, options);
}

export {
    getData,
    getDataWithoutCache,
    postData,
    putData,
    postImageData,
    deleteData,
};
